import { shouldShowUnmatchedInventory } from './inventory-linked';

export const needsCloudHostingWarning = ({
  cloudProvider,
  inventoryLinked,
  cloudAllocationId,
  deprovisionedAt,
}: {
  cloudProvider?: string | null;
  inventoryLinked?: boolean;
  cloudAllocationId?: string | null;
  deprovisionedAt?: Date | string | null;
}): boolean =>
  Boolean(cloudProvider) ||
  shouldShowUnmatchedInventory({
    cloudProvider,
    inventoryLinked,
    cloudAllocationId,
    deprovisionedAt,
  });
